module.exports = __webpack_public_path__ + "img/buessiness_xmwl_c.89edb451.png";